import { useTaxonomy } from "@/lib/taxonomy";

export function ScopeChip({ scope }: { scope: string }) {
  const { scopeColor, scopeLabel } = useTaxonomy();
  const color = scopeColor(scope);
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full px-1.5 py-0.5 text-[0.625rem] font-semibold uppercase leading-none tracking-wide ${color.chip}`}
    >
      {scopeLabel(scope)}
    </span>
  );
}
